import React from "react";
import { Card, Button, Breadcrumb } from "antd";
import { Link } from "react-router-dom";

const gridStyle = {
  width: "275px",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },

          {
            title: "Bantuan",
          },
        ]}
      />
    }
  >
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="panduan registrasi inageoportal"
            src={
              process.env.PUBLIC_URL +
              "/static/images/panduan_registrasi_inageoportal.png"
            }
          />
        }
        actions={[
          <Link target="_blank" to="/static/Panduan Registrasi Inageo V3.pdf">
            <Button type="primary">Lihat Dokumen</Button>
          </Link>,
        ]}
        title="Panduan Registrasi"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="panduan unduh data demnas"
            src={
              process.env.PUBLIC_URL + "/static/images/panduan_unduh_demnas.png"
            }
          />
        }
        actions={[
          <Link target="_blank" to="/static/Panduan Unduh Data Demnas.pdf">
            <Button type="primary">Lihat Dokumen</Button>
          </Link>,
        ]}
        title="Panduan Unduh Data Demnas"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="panduan unduh data demnas"
            src={
              process.env.PUBLIC_URL +
              "/static/images/Standar_Data_Geospasial_Handbook.png"
            }
          />
        }
        actions={[
          <Link
            target="_blank"
            to="/static/Standar Data Geospasial Handbook.pdf"
          >
            <Button type="primary">Lihat Dokumen</Button>
          </Link>,
        ]}
        title="Standar Data Geospasial Handbook"
      ></Card>
    </Card.Grid>
  </Card>
);
export default App;
